import script from "./danh-sach-socket.vue?vue&type=script&setup=true&lang=js"
export * from "./danh-sach-socket.vue?vue&type=script&setup=true&lang=js"

import "./danh-sach-socket.vue?vue&type=style&index=0&id=ef5e565a&scoped=true&lang=css"
import "./danh-sach-socket.vue?vue&type=style&index=1&id=ef5e565a&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef5e565a"]])

export default __exports__